module.exports = __webpack_public_path__ + "img/consultBtn1.cba4c441.svg";